import React from 'react';

import Tools from '../../components/Tools/Tools';
import OurExperts from './OurExperts/OurExperts';
import OwnBusiness from './OwnBusiness/OwnBusiness';
import BusinessPhases from './BusinessPhases/BusinessPhases';
import AnimationSection from './AnimationSection/AnimationSection';
import CoursePackets from '../../components/CoursePackets/CoursePackets';
import Comfortability from '../../components/Comfortability/Comfortability';
import FreeConsultation from '../../components/FreeConsultation/FreeConsultation';
import WeProvideConditions from '../../components/WeProvideConditions/WeProvideConditions';

import { freeConsultationId } from './AnimationSection/Hero/Hero';
import { useScrollToTopOnMount } from '../../hooks/useScrollToTopOnMount';
import { sectionIds } from '../../utils/constants';
import { PagesEnum } from '../../utils/enums';

import './entrepreneurSchool.scss';
import { useAccessibility } from '../../contexts/AccessibilityContext';

const EntrepreneurSchool = () => {
  useScrollToTopOnMount();
  const {
    settings: { theme },
  } = useAccessibility();

  return (
    <main className='school-page page'>
      <AnimationSection />
      <Tools id={sectionIds[PagesEnum.School].tools} theme={theme} />
      <FreeConsultation
        id={sectionIds[PagesEnum.School].consultation}
        title='НЕ ЗНАЕШЬ С ЧЕГО НАЧАТЬ?'
        subTitle='ЗАПИШИСЬ НА БЕСПЛАТНУЮ КОНСУЛЬТАЦИЮ'
        description='Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом'
      />
      <CoursePackets id={sectionIds[PagesEnum.School].coursePackets} />
      <OurExperts id={sectionIds[PagesEnum.School].ourExperts} />
      <OwnBusiness id={sectionIds[PagesEnum.School].ownBusiness} />
      <BusinessPhases id={sectionIds[PagesEnum.School].businessPhases} />
      <FreeConsultation
        title='НАЧНИ ПРЯМО СЕЙЧАС'
        subTitle='ЗАПИШИСЬ НА БЕСПЛАТНУЮ КОНСУЛЬТАЦИЮ'
        description='Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом'
      />
      <Comfortability id={sectionIds[PagesEnum.School].comfortability} />
      <WeProvideConditions id={sectionIds[PagesEnum.School].weProvideConditions} />
    </main>
  );
};

export default EntrepreneurSchool;
